import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import GroundFloorDurableFunctionInstanceList from '../../GroundFloorDurableFunctionInstanceList';
import moment from 'moment';
import { CommandBarButton, DatePicker, DefaultButton, DialogType, MessageBarType, PrimaryButton } from 'office-ui-fabric-react';
import HelpBox from './HelpBox';
import { GroundFloorDurableFunctionInstance } from '../../../models/DurableFunctionInstance';
import Actions from '../../../redux/Actions';
import School from '../../../models/School';
import DialogBox from '../../DialogBox';
import { SchoolWorkloadConfig } from '../../../models/SchoolWorkloadConfig';
import {buildIndexedSchools} from "../../../utils/IndexedSchools";
import SchoolPageTitle from '../../SchoolPageTitle';
import AdminSchoolMenu from '../../AdminSchoolMenu';

interface ArchiveToolPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
}

interface ArchiveToolPageState {
    startDate?: Date;
    endDate?: Date;
    workloadInstance?: GroundFloorDurableFunctionInstance;
    currentWorkloadId?: string;
    school?: School;
    config?: SchoolWorkloadConfig;
    
    dialogTitle?: string;
    dialogSubText?: string;
    dialogOnConfirm?(): void;
    hideDialogueBox: boolean
}

class ArchiveToolPage extends Component<ArchiveToolPageProps & DispatchProps, ArchiveToolPageState> {

    constructor(props: ArchiveToolPageProps & DispatchProps) {
        super(props);

        this.state = {
            hideDialogueBox: true
        }
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.loadDataAndSetState();
        }
    }

    async componentDidUpdate(prevProps: Readonly<ArchiveToolPageProps & DispatchProps>, prevState: Readonly<ArchiveToolPageState>, snapshot?: any): Promise<void>
    {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.loadDataAndSetState();
        }

        if (this.state.currentWorkloadId != prevState.currentWorkloadId) {
            this.refreshCurrentWorkloadInstance(this.state.currentWorkloadId!);
        }
    }

    private async loadDataAndSetState() {
        var config = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
        var school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode);

        this.setState({
            startDate: moment(config.sdsStartDate).toDate(),
            endDate: moment(config.sdsEndDate).toDate(),
            school,
            config
        });
    }

    private checkDatesAreValid(): boolean {
        if (moment(this.state.endDate).isBefore(this.state.startDate)) {
            this.props.dispatch(Actions.showMessageBar("End date must be after start date", MessageBarType.error))
            return false;
        }

        return true;
    }
    
     private startArchiveWorkload = async () => {
         if (!this.checkDatesAreValid()) {
             return;
         }
    
         var startDateString = this.state.startDate?.toDateString();
         var endDateString = this.state.endDate?.toDateString();
    
         try {
             var workloadId = await this.props.apiService.startArchiveWorkloadWithDates(this.props.tenantId, this.props.schoolCode, startDateString!, endDateString!);
             this.setState({ currentWorkloadId: workloadId })
         } catch (e) {
             console.log(e)
             this.props.dispatch(Actions.showMessageBar(`Error starting archive workload: ${e}`, MessageBarType.error))
         }
    }

    private async startUnArchiveWorkload() {
        if (!this.checkDatesAreValid()) {
            return;
        }

        var startDateString = this.state.startDate?.toDateString();
        var endDateString = this.state.endDate?.toDateString();

        try {
            var workloadId = await this.props.apiService.startUnArchiveWorkloadWithDates(this.props.tenantId, this.props.schoolCode, startDateString!, endDateString!);
            this.setState({ currentWorkloadId: workloadId })
        } catch (e) {
            console.log(e)
            this.props.dispatch(Actions.showMessageBar(`Error starting un-archive workload: ${e}`, MessageBarType.error))
        }
    }

    private async startDisconnectWorkload() {
        if (!this.checkDatesAreValid()) {
            return;
        }

        var startDateString = this.state.startDate?.toDateString();
        var endDateString = this.state.endDate?.toDateString();

        try {
            var workloadId = await this.props.apiService.startDisconnectWorkloadWithDates(this.props.tenantId, this.props.schoolCode, startDateString!, endDateString!);
            this.setState({ currentWorkloadId: workloadId })
        } catch (e) {
            console.log(e)
            this.props.dispatch(Actions.showMessageBar(`Error starting disconnect workload: ${e}`, MessageBarType.error))
        }
    }

    private refreshCurrentWorkloadInstance = async (id: string) => {
        try {
            var workload = await this.props.apiService.getGroundFloorDurableFunctionInstance(id);
            this.setState({ workloadInstance: workload })
        } catch (e) {
            console.log(e)
            this.props.dispatch(Actions.showMessageBar(`Error retrieving workload: ${e}`, MessageBarType.error))
        }        
    }

    private refreshWorkloadList = async () => {
        if (this.state.currentWorkloadId == undefined) {
            return;
        }

        await this.refreshCurrentWorkloadInstance(this.state.currentWorkloadId!);
    }

    private terminateWorkload = async () => {
        if (this.state.currentWorkloadId == undefined) {
            return;
        }

        try {
            await this.props.apiService.terminateGroundFloorDurableFunctionInstance(this.state.currentWorkloadId!);
        } catch (e) {
            console.log(e)
            this.props.dispatch(Actions.showMessageBar(`Error terminating workload: ${e}`, MessageBarType.error))
        }
        finally {
            setTimeout(() => { this.refreshCurrentWorkloadInstance(this.state.currentWorkloadId!) }, 1300);
            await this.props.dispatch(Actions.showMessageBar("Workload Terminated", MessageBarType.success));
        }
    }
    
    private showDialog(title: string,subText: string,onConfirm: () => any)
    {
        const onConfirmAndClose = () =>
        {
            onConfirm();
            this.setState({
                hideDialogueBox: true
            });
        };
        
        this.setState({
            dialogTitle: title,
            dialogSubText: subText,
            hideDialogueBox: false,
            dialogOnConfirm: onConfirmAndClose
        });
    }
    
    private renderDialog(): JSX.Element
    {
        return (
            <DialogBox
                hidden={this.state.hideDialogueBox}
                type={DialogType.normal}
                title={this.state.dialogTitle!}
                subText={this.state.dialogSubText!}
                onDismiss={() => { this.setState({hideDialogueBox: true}); }}
            >
                <PrimaryButton
                    text="Start"
                    className={""}
                    onClick={this.state.dialogOnConfirm}
                />
            </DialogBox>
        );
    }
    
    
    public render(): JSX.Element {

        const refreshButton = (
            <CommandBarButton
                iconProps={{ iconName: "Refresh" }}
                text="Refresh"
                onClick={this.refreshWorkloadList}
            />
        );

        const terminateButton = (
            <CommandBarButton
                iconProps={{ iconName: "ErrorBadge" }}
                text="Terminate"
                onClick={this.terminateWorkload}
            />
        );

        const buttonsDisabled = this.state.currentWorkloadId != undefined ? true : false 

        const customStartDate = moment(this.state.startDate).format("DD-MM-YYYY");
        const customEndDate = moment(this.state.endDate).format("DD-MM-YYYY");

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Archive Tool" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                <HelpBox
                    TitleText="Archive Tool"
                    HelpBoxText={
                        "Archive all class teams within a chosen date range using the date pickers below. You can also disconnect all class teams from SDS or run the un-archive workload  within the SDS dates from the workload config if needed. Please be aware this tool can only be used once before you will have to refresh to prevent workloads being run accidently"
                    }
                    Icon={'Archive'}
                />

                <div className="flex-row flex--justify-content-space-evenly">
                    <div className={"archive-tool-column"}>
                        <div className={"card"}>
                            <div className={"card__header"} >
                                <span className={"card__title"}>Archive Teams Within The Selected Dates</span>
                            </div>
                        <div className="flex-item--flex-1 flex-column flex--align-items-center card__content">
                            
                            <h3>Select Dates</h3>
                            <DatePicker
                                className={"filter-controls__input"}
                                label={"Archive Start Date"}
                                value={this.state.startDate}
                                onSelectDate={(selectedDate?: Date | undefined | null) => {
                                    this.setState({ startDate: selectedDate as Date })
                                    console.log(`Start Date: ${this.state.startDate}`)
                                }}
                                placeholder="Select a date..."
                                ariaLabel="Select a date"
                            />

                            <DatePicker
                                className={"filter-controls__input"}
                                label={"Archive End Date"}
                                value={this.state.endDate}
                                onSelectDate={(selectedDate?: Date | undefined | null) => {
                                    this.setState({ endDate: selectedDate as Date })
                                    console.log(`Start Date: ${this.state.endDate}`)
                                }}
                                placeholder="Select a date..."
                                ariaLabel="Select a date"
                            />

                            <PrimaryButton
                                text="Start Disconnect and Archive"
                                className={"archive-tool-button"}
                                onClick={() => {
                                    this.showDialog("Run Achive Workload", `Are you sure you want to archive classes between ${customStartDate} and ${customEndDate}. This will create a membership snapshot, disconnect and archive all class teams that were created between the dates selected in the date pickers`, () => {
                                        this.startArchiveWorkload();
                                    });
                                }}
                                disabled={buttonsDisabled}
                                />

                            <div className="flex-row">

                                <DefaultButton
                                    text="Start Un-Archive Teams"
                                    className={"archive-tool-button"}
                                    onClick={() => {
                                        this.showDialog("Run Un-Archive Between Custom Dates", `Are you sure you want to un-archive all class teams between ${customStartDate} and ${customEndDate}. This will un-archive all class teams created between these dates.`, () => {
                                            this.startUnArchiveWorkload();
                                        })
                                    }}
                                    disabled={buttonsDisabled}
                                />

                                <DefaultButton
                                    text="Start Disconnect Teams"
                                    className={"archive-tool-button"}
                                    onClick={() => {

                                        this.showDialog("Run Disconnect Between Custom Dates", `Are you sure you want to disconnect all class teams between ${customStartDate} and ${customEndDate}. This will disconnect all class teams created between these dates from SDS and allow the rollover to be completed.`, () => {
                                            this.startDisconnectWorkload()
                                        })

                                    }}
                                    disabled={buttonsDisabled}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"archive-tool-column"}>
                        {this.state.currentWorkloadId != undefined ? <GroundFloorDurableFunctionInstanceList
                            title={'Archive Workload'}
                            enableRowLinks={true}
                            indexedSchools={buildIndexedSchools(this.state.school ? [this.state.school] : [])}
                            instances={this.state.workloadInstance ? [this.state.workloadInstance] : [] }
                            headerExtra={<Fragment>{terminateButton} {refreshButton}</Fragment>}
                        /> : null}
                    </div>
                </div>
                
                {this.renderDialog()}

            </Fragment>
        ); 
    }
}

export default connect(
    (state: IRootState, ownProps: any): ArchiveToolPageProps => {

        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            apiService: state.auth.apiService
        };
    }
)(ArchiveToolPage)